import { render, staticRenderFns } from "./TopKeyword.vue?vue&type=template&id=734838e4&scoped=true"
import script from "./TopKeyword.vue?vue&type=script&lang=js"
export * from "./TopKeyword.vue?vue&type=script&lang=js"
import style0 from "./TopKeyword.vue?vue&type=style&index=0&id=734838e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734838e4",
  null
  
)

export default component.exports